import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { PrimaryButton } from '../ui/PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
export function Hero() {
  return <header className="relative overflow-hidden bg-white pb-10 pt-8 sm:pb-14 sm:pt-12" data-id="element-89" data-mp="cv34dxipuggd">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[380px] w-[680px] -translate-x-1/2 rounded-full bg-accent/10 blur-3xl" aria-hidden="true" data-id="element-90" data-mp="hvz2fugdz8dv" />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-91" data-mp="quubdeatewkv">
        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-92" data-mp="vm2lkcjyylz3">
          <SectionTag icon="🏋️" tone="accent" data-id="element-93" data-mp="10kdxqtxql8kh">
            Enciclopedia Pilates 360™
          </SectionTag>
        </m.div>

        <m.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-5 font-heading text-3xl font-bold leading-[1.15] tracking-tight text-primary sm:text-4xl md:text-5xl" data-id="element-94" data-mp="15mcxzuy6jpd7">
          Deja de perder horas eligiendo ejercicios y organizando secuencias para tus clases
        </m.h1>

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.18
      }} className="mt-5 max-w-2xl text-base leading-relaxed text-ink sm:text-lg" data-id="element-95" data-mp="3vvarsdwjefec">
          Organiza tus sesiones con Enciclopedia Pilates 360: 6 tomos digitales con ejercicios,
          indicaciones de ejecución, errores frecuentes, correcciones y progresiones para adaptar el
          trabajo a tus alumnos.
        </m.p>

        <m.img src="https://cdn.magicpatterns.com/uploads/wpgdUCDKLVtn9MUf5ZULrH/ChatGPT_Image_3_sept_2026__22_57_24-removebg-preview.png" alt="Enciclopedia Pilates Profesional 360: colección de 6 tomos, 6 bonos y accesorios" width={640} height={620} initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.24
      }} className="mt-8 w-full max-w-md sm:max-w-lg" data-id="element-96" data-mp="em469yqvabuu" />

        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.32
      }} className="mt-7 flex flex-col items-center" data-id="element-97" data-mp="2qvckv36460lp">
          <PrimaryButton href={CHECKOUT_URL} data-id="element-98" data-mp="2hu4kmfk1epoz">Quiero organizar mis clases</PrimaryButton>
          <p className="mt-3 text-xs text-ink/60 sm:text-sm" data-id="element-99" data-mp="2mw3pxuzc7wok">
            Material digital en PDF · Acceso inmediato
          </p>
        </m.div>
      </div>
    </header>;
}